'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$scope', 'MunicipalityService',
    function ($scope, MunicipalityService) {
        $scope.municipalities = [];
        MunicipalityService.api.get(null, (data) => $scope.municipalities = [{
            id: null,
            name: "<Все>"
        }].concat(data._embedded));
    }];
